import { get, post } from "../../config/api";

export const Auth = {
  login: ({ secret }: { secret: string }) =>
    post(`auth/login`, { json: { secret } }),
};
